import {ChangeDetectionStrategy, Component, inject, Input} from '@angular/core';
import {SelectPipe} from '@aviary/pipes/select.pipe';
import {NotificationsActions} from '@store/notifications/notifications.actions';
import {Store} from '@ngrx/store';
import {NotificationsSelectors} from '@store/notifications/notifications.selectors';
import {ViewportSelectors} from '@aviary/store/viewport/viewport.selectors';
import {NotificationListItemComponent} from '@lib/components/notifications/list-item/notification-list-item.component';
import {NgClass} from '@angular/common';
import {MatIcon} from '@angular/material/icon';
import {TextButtonComponent} from '@aviary/buttons/text-button/text-button.component';
import {HiddenUntilLoadedDirective} from '@aviary/directives/hidden-until-loaded.directive';

@Component({
  selector: 'px-notification-list',
  templateUrl: './notification-list.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SelectPipe, NotificationListItemComponent, NgClass, MatIcon, TextButtonComponent, HiddenUntilLoadedDirective]
})
export class NotificationListComponent {
  @Input() isDashboardView: boolean = false;
  public readonly store = inject(Store);
  public readonly notificationsSelectors = NotificationsSelectors.Notifications;
  public readonly viewportSelectors = ViewportSelectors;

  public clearAllNotifications(): void {
    this.store.dispatch(NotificationsActions.markAllNotificationsAsRead());
  }
}
